import Daily from '../components/Daily.vue';
import Login from '../components/Login.vue';
import Logout from '../components/Logout.vue';
import MySched from '../components/MySched.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {path: '/myschedule', name: 'My Schedule', protected: true, component: MySched},
    {path: '/daily', name: 'Daily', component: Daily},
    {path: '/login', component: Login},
    {path: '/logout', component: Logout},
    {path: '*', redirect: '/daily'}
];

export default new VueRouter({routes});